var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXpoTabLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9318 17.2467L25.4556 29.6687H16.6539L14.3376 25.8712C13.5269 24.5444 13.1331 23.7894 12.6004 22.4855C12.1372 23.5149 11.4654 24.7731 10.7242 25.9627L8.73226 29.6459H0.0231326L8.63961 17.2467L-3.05176e-05 6.22021H8.50063C8.50063 6.22021 12.3688 11.5733 12.9015 12.7629C13.2953 11.8936 16.816 6.22021 16.816 6.22021H25.4556L16.9318 17.2467Z",
    fill: "#CC0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4387 6.22021C39.33 6.22021 41.1135 6.56336 42.7349 7.66144C44.9353 9.10267 46.1861 11.5733 46.1861 14.5244C46.1861 16.8121 45.3754 18.7795 43.8467 20.2893C42.3179 21.7763 40.3491 22.4397 37.2222 22.4397H32.9834V29.6459H25.4788V6.22021H35.4387ZM32.9834 16.9265H35.9019C38.0097 16.9722 38.8899 16.1944 38.8899 14.5015C38.8899 12.8087 37.8939 12.008 35.7629 12.008H33.0066V16.9265H32.9834Z",
    fill: "#CC0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0436 17.979C70.0436 25.3224 65.2258 30.218 58.1148 30.218C50.8418 30.218 45.9777 25.3681 45.9777 17.9332C45.9777 10.5212 50.8186 5.62561 58.1843 5.62561C65.2721 5.62561 70.0436 10.6356 70.0436 17.979ZM53.5518 17.8417C53.5518 22.0281 55.0806 24.4531 58.1148 24.4531C61.0797 24.4531 62.4926 22.0968 62.4926 17.6587C62.4926 13.7239 60.9638 11.3905 58.0685 11.3905C55.15 11.3905 53.5518 13.8612 53.5518 17.8417Z",
    fill: "#CC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpoTabLogo);
export default __webpack_public_path__ + "static/media/xpo-tab-logo.dba4379bff382f9e94f310c241b6c30e.svg";
export { ForwardRef as ReactComponent };